function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.25 17.5C18.0136 17.5 16.8773 17.9276 15.9802 18.6427L10.3755 15.1397C10.5415 14.389 10.5415 13.611 10.3755 12.8602L15.9802 9.35725C16.8773 10.0724 18.0136 10.5 19.25 10.5C22.1495 10.5 24.5 8.14948 24.5 5.25C24.5 2.35052 22.1495 0 19.25 0C16.3505 0 14 2.35052 14 5.25C14 5.64145 14.0432 6.02273 14.1245 6.38974L8.51976 9.8927C7.62273 9.1776 6.48637 8.75 5.25 8.75C2.35052 8.75 0 11.1005 0 14C0 16.8995 2.35052 19.25 5.25 19.25C6.48637 19.25 7.62273 18.8224 8.51976 18.1073L14.1245 21.6103C14.0416 21.9845 13.9999 22.3667 14 22.75C14 25.6495 16.3505 28 19.25 28C22.1495 28 24.5 25.6495 24.5 22.75C24.5 19.8505 22.1495 17.5 19.25 17.5Z",
  fill: "#FFC300"
});
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2f153d3a31639d4edd50da46ff8448e7.svg";
export { ForwardRef as ReactComponent };